import Button from '@berlitz/button'
import Card from '@berlitz/card'
import { Col, Row } from 'react-styled-flexboxgrid'
import styled, { css } from 'styled-components'
import { CounterProps, StyledCardProps } from './interface'

export const StyledRow = styled(Row)`
  div:nth-child(2) {
    margin-left: ${({ theme }) => theme.space.sm};
    margin-right: ${({ theme }) => theme.space.sm};

    .alert-icon {
      top: auto;
    }
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    div:nth-child(2) {
      margin-left: ${({ theme }) => theme.space.sm};
      margin-right: ${({ theme }) => theme.space.sm};
    }
  }
`

export const HeaderButton = styled(Button)`
  display: block;
  margin-top: ${({ theme }) => theme.space.xs};
  padding-top: ${({ theme }) => theme.space.xs};
  padding-bottom: ${({ theme }) => theme.space.xs};
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    display: inline;
    margin-top: 0;
    margin-left: ${({ theme }) => theme.space.xs};
  }
`

export const StyledP = styled.p`
  color: ${({ theme }) => theme.colors.brandPrimary};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  font-size: ${({ theme }) => theme.fontSize.xxs};
`

export const BoldP = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  font-size: ${({ theme }) => theme.fontSize.xs};
`

export const IconBg = styled.div`
  background: ${({ theme, color = 'blueGray' }) => theme.palette[`${color}10`]};
  padding: ${({ theme }) => theme.space.sm};
  border-radius: 50%;
  svg {
    color: ${({ theme, color = 'blueGray' }) => theme.palette[`${color}100`]};
    font-size: ${({ theme }) => theme.fontSize.md};
  }
`

export const StyledCol = styled(Col)`
  margin-bottom: ${({ theme }) => theme.space.lg};
`

export const ContentWrapper = styled.div`
  display: flex;
  align-items: center;

  h3 {
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    margin-left: ${({ theme }) => `${theme.space.sm}`};
    font-size: ${({ theme }) => theme.fontSize.xs};
  }
`

export const StyledCard = styled(Card)`
  ${({ active, color = 'blueGray' }: StyledCardProps) =>
    active &&
    css`
      border: 3px solid ${({ theme }) => theme.palette[`${color}100`]};
      background: ${({ theme }) => theme.palette[`${color}10`]};
      ${IconBg} {
        background: ${({ theme }) => theme.colors.brandPrimaryContrast};
      }
    `}
`

export const FooterButton = styled(Button)`
  padding-top: ${({ theme }) => theme.space.xs};
  padding-bottom: ${({ theme }) => theme.space.xs};
  float: right;
  margin-left: ${({ theme }) => theme.space.md};
  height: ${({ theme }) => theme.layout.sm};
  svg {
    margin-right: ${({ theme }) => theme.space.xs};
  }
`

export const ProgramSelect = styled.div`
  display: flex;
  align-items: baseline;
  background-color: ${({ theme }) => theme.colors.brandPrimaryContrast};
  border-radius: ${({ theme }) => theme.radius.md};
  padding: ${({ theme }) => `${theme.space.sm} ${theme.space.md}`};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
  }
`

export const ProgramLabel = styled.div`
  white-space: nowrap;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  font-size: ${({ theme }) => theme.fontSize.sm};
  div {
    padding-right: ${({ theme }) => theme.space.xs};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-bottom: ${({ theme }) => theme.space.xs};
  }
`

export const Counter = styled.div<CounterProps>`
  font-size: ${({ theme }) => theme.fontSize.xxxs};
  color: ${({ theme }) => theme.colors.text02};
  float: right;
  margin-top: -20px;
  margin-right: ${({ theme }) => theme.space.md};
  position: relative;
  z-index: 1;

  ${({ error }) =>
    error &&
    css`
      color: ${({ theme }) => theme.colors.uiError};
    `}
`

export const CategoryCard = styled(Card)<StyledCardProps>`
  display: flex;
  min-width: 220px;
  border-radius: 3px;

  & > div {
    padding: 0;
  }

  ${({ theme }) => `
    background-color: ${theme.palette.white};
    border: 1px solid ${theme.palette.gray100};
    padding: ${theme.space.xs};
    h3 {
      font-weight: ${theme.fontWeight.bold};
      font-size: ${theme.fontSize.xs};
      margin-bottom: ${theme.space.xs};
      line-height: 1.38;
      letter-spacing: 0.56px;
    }

    p {
      font-size: ${theme.fontSize.xxxs};
      font-weight: normal;
      line-height: 1.33;
      letter-spacing: 0.42px;
      color: ${theme.palette.blueGray50};
    }
  `}

  ${({ active, color = 'blueGray' }) =>
    active &&
    css`
      border: 3px solid ${({ theme }) => theme.palette[`${color}100`]};
      background: ${({ theme }) => theme.palette[`${color}10`]};
      ${IconBg} {
        background: ${({ theme }) => theme.colors.brandPrimaryContrast};
      }
    `}
`

export const CategtoryCardContent = styled.div`
  display: flex;

  ${({ theme }) => `
    gap: ${theme.space.xs};
  `}
`

export const CategoryDetails = styled.div`
  padding: ${({ theme }) => theme.space.xxs} 0;
`

export const CategoryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  a {
    height: 100%;
  }
  ${({ theme }) => `
    gap: ${theme.space.xs};
  `}
`

export const CategoryCardWrapper = styled.div`
  text-decoration: none;
  cursor: pointer;
  height: inherit;
`
